module.exports = __webpack_public_path__ + "static/img/3-wrong-exchange.c83cb32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-wrong-exchange.png
// module id = 1339
// module chunks = 0